import { Navigate, Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { Provider } from 'react-redux';
import './App.css';
import LoginScreen from './screens/LoginScreen';
import TranslationScreen from './screens/TranslationScreen';
import AddTranslationScreen from './screens/AddTranslationScreen';
import ProtectedRoute from './auth/ProtectedRoute';
import { ToastProvider, LoadingProvider } from './providers';
import { store } from './store';
import theme from './theme';
import { MsalProvider } from '@azure/msal-react';
import { msalInstance } from './auth/authProvider';
import { useEffect, useState } from 'react';
import LoadingContainer from './components/LoadingContainer';

function App() {
  const [msalInitialized, setMsalInitialized] = useState(false);

  useEffect(() => {
    const initializeMsal = async () => {
      try {
        await msalInstance.initialize();
        await msalInstance.handleRedirectPromise();
        setMsalInitialized(true);
      } catch (error) {
        console.error('MSAL initialization failed:', error);
        setMsalInitialized(true); // Still render app even if initialization fails
      }
    };

    initializeMsal();
  }, []);

  if (!msalInitialized) {
    return (
      <LoadingContainer />
    );
  }

  return (
    <MsalProvider instance={msalInstance}>
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <LoadingProvider>
            <ToastProvider>
              <div className="App">
                <Router>
                  <Routes>
                    <Route path="/" element={<Navigate to="/login" replace />} />
                    <Route path="/login" element={<LoginScreen />} />
                    <Route
                      path="/translations"
                      element={
                        <ProtectedRoute>
                          <TranslationScreen />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/addtranslation"
                      element={
                        <ProtectedRoute>
                          <AddTranslationScreen />
                        </ProtectedRoute>
                      }
                    />
                  </Routes>
                </Router>
              </div>
            </ToastProvider>
          </LoadingProvider>
        </ThemeProvider>
      </Provider>
    </MsalProvider>
  )
}

export default App;
